<svelte:options customElement="hb-navbar" />

<script lang="ts">
  /**
   * Svelte Video Gallery WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import pkg from "../../../package.json";
  import type { IUserMenu } from "./types/webcomponent.type";
  import { addComponent, LanguageTranslator } from "wc-js-utils";
  import type { Events as DropdownSimpleEvents } from "../dropdown-simple/types/webcomponent.type";
  import type { Component, Events } from "./types/webcomponent.type";
  let {
    id = "",
    // style = "",
    noburger = undefined,
    usermenu = undefined,
    companybrandname = "",
    companylogouri = "",
    switchopen = undefined,
  }: Component = $props();

  let isOpen: boolean;
  $effect(() => {
    // if (style) {
    //     dropdownSimpleStyleSetup?.vars
    //   );
    // }
    if (!switchopen || switchopen === "no") {
      switchopen = "no";
      isOpen = false;
    } else {
      isOpen = true;
    }

    if (usermenu && typeof usermenu === "string") {
      try {
        usermenu = JSON.parse(usermenu);
      } catch (err) {
        console.error("error parsing usermenu", usermenu, err);
      }
    }
  });

  addComponent({
    repoName: "@htmlbricks/hb-dropdown-simple",
    version: pkg.version,
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  function switchMenu() {
    isOpen = !isOpen;
    dispatch("navmenuswitch", {
      isOpen,
    });
  }
</script>

<nav class="level is-mobile mb-0 py-2 px-3 hb-navbar" role="navigation">
  <div class="level-left">
    <div
      class="level-item is-flex is-align-items-center is-justify-content-flex-start hb-navbar__left"
      id="left_side"
      part="left-slot"
    >
      {#if !noburger}
        <button
          type="button"
          class="hb-navbar__menu-btn"
          onclick={() => switchMenu()}
        >
          <slot name="nav-switcher">☰</slot>
        </button>
      {/if}
      <!-- svelte-ignore a11y_click_events_have_key_events -->
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <span
        class="hb-navbar__slot is-clickable pl-2"
        role="button"
        tabindex="0"
        onclick={() => dispatch("navbarSlotClick", { side: "left" })}
        onkeydown={(e) =>
          e.key === "Enter" && dispatch("navbarSlotClick", { side: "left" })}
        ><slot name="left-slot" /></span
      >
    </div>
  </div>

  <div
    class="level-item has-text-centered hb-navbar__center"
    id="center_side"
    part="center-slot"
  >
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <span
      class="hb-navbar__slot is-clickable"
      role="button"
      tabindex="0"
      onclick={() => dispatch("navbarSlotClick", { side: "center" })}
      onkeydown={(e) =>
        e.key === "Enter" && dispatch("navbarSlotClick", { side: "center" })}
    >
      <slot name="brand">
        {#if companylogouri}<img
            class="hb-navbar__brand-logo"
            alt=""
            src={companylogouri}
          />{/if}
        {companybrandname}
      </slot>
    </span>
    <slot name="center-slot" />
  </div>

  <div class="level-right">
    <div class="level-item hb-navbar__right" id="rigth_side" part="right-slot">
      <div
        id="rigth_side_content"
        class="is-flex is-align-items-center is-justify-content-flex-end pr-2"
      >
        <slot name="right-slot"></slot>
        {#if usermenu}
          <hb-dropdown-simple
            ondropDownClick={(e: {
              detail: DropdownSimpleEvents["dropDownClick"];
            }) =>
              dispatch(
                "navbarDropDownClick",
                e.detail ? { key: e.detail.key } : { key: "" },
              )}
            list={JSON.stringify(usermenu.list)}
            position="right"
            ><span slot="dropdownbutton"
              ><img
                class="hb-navbar__avatar"
                alt=""
                src={usermenu.imgUri}
              /></span
            ></hb-dropdown-simple
          >
        {/if}
      </div>
    </div>
  </div>
</nav>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
